module.exports = __webpack_public_path__ + "static/cover-just-a-game-c521d64a7a6b8f0a9dac0d35c8e0dc82.jpg";